
















































































































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../../honcierge-api"
import axios, { AxiosError } from "axios"
import Base64Uploader from "@/components/Base64Uploader.vue"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import { Category, PartiallyNullable, SubCategory } from "types/index"
import ErrorMessages from "@/components/ErrorMessages.vue"

@Component({
  components: { Base64Uploader, ErrorMessages, DeleteButtonWithConfirm },
})
export default class EditDialog extends Vue {
  @Prop({ default: null })
  private id!: number | null

  private dialog = false

  // for master
  private categories: Category["view"][] = []
  // for master
  private breadcrumbStatuses = [
    { name: "標準", value: 1 },
    { name: "パンくずのみ", value: 2 },
    { name: "パンくず利用不可", value: 3 },
  ]

  private category: PartiallyNullable<Category["view"], "id"> = {
    id: null,
    name: "",
    isEnabled: false,
    urlKey: "",
    priority: 0,
    specialFeatures: [],
  }
  private name = ""
  private isEnabled = true
  private showOnTop = true
  private urlKey = ""
  private description: string | null = null
  private breadcrumbStatus: { name: string; value: number } =
    this.breadcrumbStatuses[0]
  private order = 0
  private banner: { content: string; filename: string } = {
    content: "",
    filename: "",
  }

  private errorMessages = []

  // rules for form
  private orderRules = [(order: number) => !!order || "順序は必須です"]
  private categoryNameRules = [
    (category: Category["view"]) =>
      (category && !!category.name) || "カテゴリー名は必須です",
  ]
  private nameRules = [(name: string) => !!name || "小カテゴリー名は必須です"]
  private urlRules = [(urlKey: string) => !!urlKey || "URLは必須です"]

  public updateSubCategory(): void {
    if (!this.validate()) {
      return
    }
    const withCategory = true
    if (this.id !== null && this.category.id !== null) {
      api
        .updateSubCategory(
          {
            id: this.id,
            categoryId: this.category.id,
            name: this.name,
            urlKey: this.urlKey,
            description: this.description,
            breadcrumbStatus: this.breadcrumbStatus.value,
            order: this.order,
            isEnabled: this.isEnabled,
            showOnTop: this.showOnTop,
            bannerFilename: this.banner.filename,
            bannerContent: this.banner.content,
          },
          withCategory
        )
        .then((res) => {
          this.emitSubCategory(res.data.subCategory)
          this.$toasted.success("小カテゴリーを更新しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.errorMessages = e.response.data.messages
          }

          // 編集画面を保存前に戻しておく
          if (this.id !== null) {
            api.getSubCategory(this.id, false).then((response) => {
              const subCategory: SubCategory["data"] = response.data.subCategory
              this.order = subCategory.order
              this.category = subCategory.category
              this.name = subCategory.name
              this.urlKey = subCategory.urlKey
              this.description = subCategory.description
              this.breadcrumbStatus = this.convertBreadcrumbStatus(subCategory)
              this.isEnabled = subCategory.isEnabled
              this.showOnTop = subCategory.showOnTop
            })
          }
        })
    }
  }

  public createSubCategory(): void {
    if (!this.validate()) {
      return
    }
    if (this.category === null) {
      this.$toasted.error("カテゴリーが不正です")
      return
    }
    if (this.category.id !== null) {
      const withCategory = true
      api
        .createSubCategory(
          {
            categoryId: this.category.id,
            name: this.name,
            urlKey: this.urlKey,
            description: this.description,
            breadcrumbStatus: this.breadcrumbStatus.value,
            order: this.order,
            isEnabled: this.isEnabled,
            bannerFilename: this.banner.filename,
            bannerContent: this.banner.content,
          },
          withCategory
        )
        .then((res) => {
          this.emitSubCategory(res.data.subCategory)
          this.$toasted.success("小カテゴリーを新規作成しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.$toasted.error(e.response.data.messages)
          }
        })
    }
  }

  @Emit("emitSubCategory")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitSubCategory(subCategory: SubCategory["data"] | undefined) {
    this.close()
  }

  @Emit("close")
  private close() {
    this.dialog = false
    this.clear()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditDialog>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditDialog>
    return form.resetValidation()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.name = ""
    this.category = {
      id: null,
      name: "",
      isEnabled: false,
      urlKey: "",
      priority: 0,
      specialFeatures: [],
    }
    this.isEnabled = true
    this.showOnTop = true
    this.order = 0
    this.urlKey = ""
    this.description = null
    this.banner = { content: "", filename: "" }
    const base64Uploader = this.$refs.base64Uploader as InstanceType<
      typeof Base64Uploader
    >
    base64Uploader.filename = ""
  }

  private loadImage(image: string, filename: string) {
    this.banner.content = image
    this.banner.filename = filename
  }

  private convertBreadcrumbStatus(subCategory: SubCategory["data"]) {
    const ret = this.breadcrumbStatuses.find(
      (status) => status.name === subCategory.breadcrumbStatus
    )
    if (!ret) {
      return this.breadcrumbStatus
    }
    return ret
  }

  private async fetchMaxOrder(category: Category["view"]) {
    try {
      const response = await api.getMaxOrderForSubCategory(category.id)
      this.order = response.data.maxOrder + 10
    } catch {
      console.log("最大値の取得に失敗")
    }
  }

  public async open() {
    if (this.id !== null) {
      try {
        const withCategory = true
        const response = await api.getSubCategory(this.id, withCategory)
        const subCategory: SubCategory["data"] = response.data.subCategory
        this.order = subCategory.order
        this.category = subCategory.category
        this.name = subCategory.name
        this.urlKey = subCategory.urlKey
        this.description = subCategory.description
        this.breadcrumbStatus = this.convertBreadcrumbStatus(subCategory)
        this.isEnabled = subCategory.isEnabled
        this.showOnTop = subCategory.showOnTop
        this.banner.content = subCategory.banner.url
        this.banner.filename = subCategory.banner.filename
        this.errorMessages = []
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          this.$toasted.error(e.response.data.message)
        }
      }
    }
    // 選択用のカテゴリーリストを取得
    try {
      const categoryResponse = await api.getCategories({
        search: "",
        sortBy: "priority",
        descending: true,
        page: 1,
        per: 1000000,
        includeDisabled: false,
        fields: ["id", "name"],
      })
      this.categories = categoryResponse.data.categories
    } catch {
      this.$toasted.error("カテゴリーの取得に失敗しました")
      this.close()
    }
    this.dialog = true
  }
}
